import { Modal, Button, Stack, Text, Group, rem } from '@mantine/core';
import { IconAlertTriangle, IconCircleCheck } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

interface CompProps {
  apiFunction: ((id?: number) => void) | (() => void);
  opened: boolean;
  id?: number;
  close: () => void;
  redirectUrl?: string;
  title?: string;
  description?: string;
  confirmLabel?: string;
  confirmClassName?: string;
  variant?: 'danger' | 'confirm';
}

function ConfirmationModal({
  apiFunction,
  id,
  opened,
  close,
  redirectUrl,
  title = 'Estás seguro?',
  description = 'Esta acción no se puede deshacer',
  confirmLabel = 'Si, eliminar',
  confirmClassName = 'delete-button',
  variant = 'danger',
}: CompProps) {
  const navigate = useNavigate();
  const handleConfirm = () => {
    if (id) {
      apiFunction(id);
    } else {
      apiFunction();
    }
    close();
    if (redirectUrl) navigate(redirectUrl);
  };

  const iconColor =
    variant === 'confirm' ? 'var(--mantine-color-green-7)' : 'var(--mantine-color-red-8)';
  const Icon = variant === 'confirm' ? IconCircleCheck : IconAlertTriangle;

  return (
    <Modal.Root size="sm" opened={opened} onClose={close} centered>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Stack justify="center" align="center">
            <Icon style={{ width: rem(100), height: rem(100), color: iconColor }} />
            <Text fz={25} fw={600}>
              {title}
            </Text>
            <Text fz={18}>{description}</Text>
            <Group>
              <Button
                className={variant === 'danger' ? confirmClassName : undefined}
                color={variant === 'confirm' ? 'green' : undefined}
                onClick={handleConfirm}
              >
                {confirmLabel}
              </Button>
              <Button className="delete-outline-button" onClick={() => close()}>
                Cancelar
              </Button>
            </Group>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
}

export default ConfirmationModal;
